import {Flex, Modal} from '@mantine/core'
import type {GitHubRepository} from '@package/shared'
import {UpdateForm} from '../forms/repository/UpdateForm.tsx'

type Props = {
  repository: GitHubRepository | undefined
  opened: boolean
  onClose: () => void
}

export const EditRepositoryModal = ({repository, opened, onClose}: Props) => {
  if (!repository) return null

  return (
    <Modal opened={opened} onClose={onClose} title={'Edit repository'} size={'lg'}>
      <Flex direction={'column'} gap={'sm'}>
        <UpdateForm repository={repository} onSuccess={onClose} disabled={false} />
      </Flex>
    </Modal>
  )
}
